export const environment = {
  apiBaseUrl: 'https://staging.api.sbv360.com',
  environment: 'stag',
  NX_APP_AZURE_AD_CLIENT_ID: 'a001c22c-6d86-458d-a005-ebc2aa4966ca',
  NX_APP_AZURE_AD_AUTHORITY:
    'https://login.microsoftonline.com/de9df500-9b25-4668-8c85-c9cce76cc306/v2.0',
  NX_APP_AZURE_AD_API_SCOPE: 'api://a001c22c-6d86-458d-a005-ebc2aa4966ca/API',
};
